export const isNewLogShape = (d: unknown) =>
  Boolean(d && typeof d === "object" && ("kyc1" in d || "kyc2" in d || "kyc3" in d));

export const isStatusNotStarted = (status: string) => {
  const s = String(status ?? "").toLowerCase();
  return !s || s === "not-started" || s === "notstarted";
};

export const showLevel1Tab = (d: unknown) =>
  Boolean(
    d &&
      typeof d === "object" &&
      "kyc1" in d &&
      (d as { kyc1?: { status?: string } }).kyc1 &&
      !isStatusNotStarted((d as { kyc1: { status?: string } }).kyc1.status ?? "")
  );

export const showLevel2Tab = (d: unknown) =>
  Boolean(
    d &&
      typeof d === "object" &&
      "kyc2" in d &&
      (d as { kyc2?: { status?: string } }).kyc2 &&
      !isStatusNotStarted((d as { kyc2: { status?: string } }).kyc2.status ?? "")
  );

export const isKyc2Success = (d: unknown) =>
  String(
    (d as { kyc2?: { status?: string } } | null)?.kyc2?.status ?? ""
  ).toLowerCase() === "success";

export const isKyc3NotStarted = (d: unknown) =>
  isStatusNotStarted(
    (d as { kyc3?: { status?: string } } | null)?.kyc3?.status ?? ""
  );

export const showLevel3Tab = (d: unknown) =>
  isNewLogShape(d) && isKyc2Success(d) && !isKyc3NotStarted(d);

export function getFirstVisibleLevel(d: unknown) {
  if (showLevel1Tab(d)) return 1;
  if (showLevel2Tab(d)) return 2;
  if (showLevel3Tab(d)) return 3;
  return 1;
}

export function normalizeKycDetails(kycDetails: unknown, customerId: string) {
  if (!kycDetails || typeof kycDetails !== "object") {
    return {
      kyc1: { data: {}, smile_id_data: null, status: "" },
      kyc2: { data: {}, status: "" },
      kyc3: { data: {}, status: "" },
      userId: { _id: customerId },
    };
  }
  const root = kycDetails as Record<string, unknown>;
  const first = (root.first_stage ?? {}) as Record<string, unknown>;
  const second = (root.second_stage ?? {}) as Record<string, unknown>;
  const third = (root.third_stage ?? {}) as Record<string, unknown>;
  const secondData =
    second.data && typeof second.data === "object"
      ? { ...(second.data as Record<string, unknown>) }
      : {};
  if (!secondData.userId) secondData.userId = customerId;
  return {
    kyc1: {
      data: first.data ?? {},
      smile_id_data: first.smile_id_data ?? null,
      status: first.status ?? "",
    },
    kyc2: {
      data: secondData,
      status: second.status ?? "",
    },
    kyc3: {
      data: third.data ?? {},
      status: third.status ?? "",
    },
    userId: { _id: customerId },
  };
}
